export const sampleHeadersCreators = [
	{ label: 'fullName', key: 'fullName' },
	{ label: 'userName', key: 'userName' },
	{ label: 'email', key: 'email' },
	{ label: 'phone', key: 'phone' },
	{ label: 'platform', key: 'platform' },
	{ label: 'location', key: 'location' },
];

export const sampleHeadersCompany = [
	{ label: 'city', key: 'city' },
	{ label: 'domain', key: 'domain' },
	{ label: 'industry', key: 'industry' },
	{ label: 'name', key: 'name' },
	{ label: 'phone', key: 'phone' },
	{ label: 'state', key: 'state' },
	{ label: 'country', key: 'country' },
	{ label: 'companyType', key: 'companyType' },
	{ label: 'email', key: 'email' },
];

export const sampleHeadersProject = [
	{ label: 'projectName', key: 'projectName' },
	{ label: 'budget', key: 'budget' },
	{ label: 'startDate', key: 'startDate' },
	{ label: 'endDate', key: 'endDate' },
	{ label: 'projectStage', key: 'projectStage' },
	{ label: 'phone', key: 'phone' },
	{ label: 'currency', key: 'currency' },
	{ label: 'platform', key: 'platform' },
	{ label: 'projectType', key: 'projectType' },
];

export const sampleHeaders = [
	{ label: 'username', key: 'username' },
	{ label: 'fullname', key: 'fullname' },
	{ label: 'gender', key: 'gender' },
	{ label: 'platform', key: 'influencerType' },
	{ label: 'followers', key: 'followers' },
	{ label: 'engagement_rate', key: 'engagementRate' },
	{ label: 'estimated_reach', key: 'estimatedReach' },
	{ label: 'handle_link', key: 'handle' },
	{ label: 'posts', key: 'posts' },
	{ label: 'average_views', key: 'avgViews' },
	{ label: 'average_likes', key: 'avgLikes' },
	{ label: 'average_comments', key: 'avgComments' },
	{ label: 'interests', key: 'interests' },
	{ label: 'gender_split', key: 'gender_split' },
];